// @flow
import { compose, prop } from "ramda"
import type { Selector } from "common/redux/types"
import type { DateRange } from "data/units/date/types"
import type { OriginalReservation } from "data/reservations/types"
import type { Accessory } from "data/reservations/types"
import type { ReservationsState } from "./reducer"

const base: Selector<ReservationsState> = prop("reservations")

export const selectDates: Selector<?DateRange> = compose(
  prop("dates"),
  base,
)

export const selectOriginalReservation: Selector<?OriginalReservation> = compose(
  prop("originalReservation"),
  base,
)

export const selectAccessories: Selector<Accessory[]> = compose(
  prop("accessories"),
  base,
)

export const selectShippingAddress: Selector<?string> = compose(
  prop("shippingAddress"),
  base,
)

export const selectAvailability: Selector<DateRange[]> = compose(
  prop("availability"),
  base,
)



// WEBPACK FOOTER //
// ./src/data/reservations/selectors.js